import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { MaintenancePlan, PlanMantenimiento } from '../../../../../shared/model/maintenance-plan.model';
import { TiposService } from '../../../../../shared/services/tipos.service';
import { MaintenancePlanApi, PlanMantenimientoService } from '../../../../../shared/services/plan-mantenimiento.services';
import { CombustibleService } from '../../../../../shared/services/combustible.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-listar-plan-mantenimientos',
  templateUrl: './listar-plan-mantenimientos.component.html',
  styleUrls: ['./listar-plan-mantenimientos.component.scss']
})
export class ListarPlanMantenimientosComponent implements OnInit {

   planes: PlanMantenimiento[] = [];
  constructor(private tiposService: TiposService,
              private PlanMantenimientoService: PlanMantenimientoService,
              private CombustibleService:CombustibleService,
              private router: Router 


  ) {
    // Cargar las clases vehiculares y los tipos de combustible al inicializar el componente
    this.cargarClasesVehiculares();
    this.cargarTipoCombustibles();

    //cargar Actividades del plan de mantenimiento
    this.cargarActividadesPlanesMantenimiento();
  }
  // filtros
  textoBusqueda = '';
  filtroClase = '';
  filtroEstado: '' | 'activo' | 'inactivo' = '';
  paginaActual = 1;
  itemsPorPagina = 10;
  opcionesItemsPorPagina = [5, 10, 25, 50,100,200];
  clasesDisponibles: string[] = [];
  combustiblesDisponibles: string[] = [];   // nuevo
  // plan pendiente de confirmar cambio de estado
  planPendiente: PlanMantenimiento | null = null;
  filtroCombustible = '';   // nuevo
  cargando = false;

  ngOnInit(): void {
    this.cargarPlanes();
  }


  cargarClasesVehiculares(): void {
    this.tiposService.getTipos().subscribe(
      (tipos) => {
        this.clasesDisponibles = tipos.map(tipo => tipo.tipos);
      },
      (error) => {
        console.error('Error al cargar las clases vehiculares:', error);
      }
    );
  }

  cargarTipoCombustibles(): void {
    this.CombustibleService.getAllCombustibles().subscribe(
      (combustibles) => {
        this.combustiblesDisponibles = combustibles.map(combustible => combustible.nombre);
      },
      (error) => {
        console.error('Error al cargar los tipos de combustible:', error);
      }
    );
  }
  cargarPlanes(): void {
  this.cargando = true;

  this.PlanMantenimientoService.getAll().subscribe({
    next: (res) => {
      this.planes = res.data.map(p => this.mapPlan(p));
     // this.clasesDisponibles = [...new Set(this.planes.map(p => p.clase.toString()))];
      //this.combustiblesDisponibles = [...new Set(this.planes.map(p => p.combustible))]; // nuevo
      // console.log('combustiblesDisponibles', this.combustiblesDisponibles); // nuevo
      this.cargando = false;
    },
    error: (err) => {
      console.error('Error al obtener planes de mantenimiento:', err);
      this.cargando = false;
    }
  });
}
  mapPlan(p: MaintenancePlanApi): any {
     return {
    id: p.id,
    codigo: p.codigo,
    nombre: p.nombre,
    clase: p.clase?.tipos ?? 'Sin definir',
    marca: p.marca?.marca ?? 'Sin definir',
    combustible: p.combustible?.nombre ?? 'Sin definir',
    modelos: p.todosModelos
      ? 'Todos los modelos'
      : (p.modeloDesde && p.modeloHasta ? `${p.modeloDesde} - ${p.modeloHasta}` : 'Sin definir'),
    cilindrajes: p.todosCilindrajes
      ? 'Todos los cilindrajes'
      : (p.cilindrajeDesde && p.cilindrajeHasta ? `${p.cilindrajeDesde} - ${p.cilindrajeHasta} cc` : 'Sin definir'),
    activo: p.estado === 1,
  };
  }

  get planesFiltrados(): PlanMantenimiento[] {
  const texto = this.textoBusqueda.trim().toLowerCase();

  return this.planes.filter(p => {
    const coincideTexto = !texto ||
      p.codigo.toLowerCase().includes(texto) ||
      p.nombre.toLowerCase().includes(texto) ||
      p.modelos.toLowerCase().includes(texto) ||
      p.cilindrajes.toLowerCase().includes(texto) ||
      p.marca.toLowerCase().includes(texto);

   const coincideClase = !this.filtroClase || p.clase === this.filtroClase;
  const coincideCombustible = !this.filtroCombustible || p.combustible === this.filtroCombustible; // nuevo

    const coincideEstado =
      !this.filtroEstado ||
      (this.filtroEstado === 'activo' && p.activo) ||
      (this.filtroEstado === 'inactivo' && !p.activo);

    return coincideTexto && coincideClase && coincideCombustible && coincideEstado;
  
  });
}
 

  get totalActivos(): number {
    return this.planes.filter(p => p.activo).length;
  }

 limpiarFiltros(): void {
  this.textoBusqueda = '';
  this.filtroClase = '';
  this.filtroCombustible = '';   // nuevo
  this.filtroEstado = '';
  this.resetearPaginacion();
}

  editarPlan(plan: PlanMantenimiento): void {
    // TODO: ajustar a tu ruteo real
    // this.router.navigate(['/mantenimiento/planes', plan.id, 'editar']);
    console.log('Editar plan', plan.id);
  }

  verActividades(plan: PlanMantenimiento): void {
    console.log('Ver actividades del plan', plan);
    this.router.navigate(['/mantenimientos/crear-actividades-mantenimientos', plan.id]);
    console.log('Ver actividades del plan', plan.id);
  }

  pedirConfirmacionEstado(plan: PlanMantenimiento): void {
    this.planPendiente = plan;
  }

  cancelarConfirmacion(): void {
    this.planPendiente = null;
  }

  confirmarCambioEstado(): void {
    if (!this.planPendiente) return;

    // TODO: reemplazar por la llamada real, ej:
    // this.planesService.cambiarEstado(this.planPendiente.id, !this.planPendiente.activo).subscribe(...)
    //this.planPendiente.activo = !this.planPendiente.activo;
    this.planPendiente = null;
  }

  nuevoPlan(): void {
    // this.router.navigate(['/mantenimiento/planes/nuevo']);
    console.log('Nuevo plan');
  }

activarDesactivarPlan(plan: PlanMantenimiento): void {
  const nuevoEstado = !plan.activo;
  const accion = nuevoEstado ? 'activar' : 'desactivar';
  const accionCapitalizada = nuevoEstado ? 'Activar' : 'Desactivar';
  const colorPrincipal = nuevoEstado ? 'primary' : 'secondary';

  Swal.fire({
    title: `${accionCapitalizada} plan`,
    html: `
      <div style="font-size: 15px; color: #6c757d; margin-top: 8px;">
        ¿Deseas <strong style="color: ${colorPrincipal};">${accion}</strong> el plan:
      </div>
      <div style="font-size: 17px; font-weight: 600; margin-top: 6px; color: #343a40;">
        "${plan.nombre}"
      </div>
    `,
    iconHtml: nuevoEstado
      ? '<i class="icofont icofont-check-circled" style="color: #28a745;"></i>'
      : '<i class="icofont icofont-close-circled" style="color: #dc3545;"></i>',
    showCancelButton: true,
    confirmButtonText: `<i class="icofont icofont-check"></i> ${accionCapitalizada}`,
    cancelButtonText: 'Cancelar',
    confirmButtonColor: colorPrincipal,
    cancelButtonColor: '#6c757d',
    reverseButtons: true,
    focusCancel: true,
    customClass: {
      popup: 'rounded-4 shadow-lg',
      icon: 'border-0'
    },
    showClass: {
      popup: 'animate__animated animate__fadeInDown animate__faster'
    },
    hideClass: {
      popup: 'animate__animated animate__fadeOutUp animate__faster'
    }
  }).then((result) => {
    if (!result.isConfirmed) {
      return;
    }

    Swal.fire({
      title: `${accionCapitalizada}ndo plan...`,
      html: `<div style="color: #6c757d;">Espera un momento por favor</div>`,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading()
    });

    this.PlanMantenimientoService.cambiarEstado(plan.id, nuevoEstado).subscribe({
      next: () => {
        plan.activo = nuevoEstado;
        Swal.fire({
          title: `¡Plan ${accion === 'activar' ? 'activado' : 'desactivado'}!`,
          html: `
            <div style="color: #6c757d; font-size: 15px;">
              El plan <strong>"${plan.nombre}"</strong> fue
              <strong style="color: ${colorPrincipal};">${accion === 'activar' ? 'activado' : 'desactivado'}</strong>
              correctamente.
            </div>
          `,
          icon: 'success',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: colorPrincipal,
          customClass: { popup: 'rounded-4 shadow-lg' },
          showClass: { popup: 'animate__animated animate__zoomIn animate__faster' }
        });
      },
      error: (err) => {
        console.error(`Error al ${accion} el plan:`, err);
        Swal.fire({
          title: `No se pudo ${accion} el plan`,
          html: `
            <div style="color: #6c757d; font-size: 15px;">
              Ocurrió un problema al intentar <strong>${accion}</strong> el plan
              <strong>"${plan.nombre}"</strong>. Intenta nuevamente.
            </div>
          `,
          icon: 'error',
          confirmButtonText: 'Entendido',
          confirmButtonColor: '#dc3545',
          customClass: { popup: 'rounded-4 shadow-lg' },
          showClass: { popup: 'animate__animated animate__shakeX animate__faster' }
        });
      }
    });
  });
}

  // slice de la página actual, lo que realmente pinta la tabla
get planesPaginados(): PlanMantenimiento[] {
  const inicio = (this.paginaActual - 1) * this.itemsPorPagina;
  return this.planesFiltrados.slice(inicio, inicio + this.itemsPorPagina);
}

get totalPaginas(): number {
  return Math.max(1, Math.ceil(this.planesFiltrados.length / this.itemsPorPagina));
}

// array de números de página, con "..." cuando hay muchas
get paginasVisibles(): (number | '...')[] {
  const total = this.totalPaginas;
  const actual = this.paginaActual;
  const paginas: (number | '...')[] = [];

  if (total <= 7) {
    for (let i = 1; i <= total; i++) paginas.push(i);
    return paginas;
  }

  paginas.push(1);
  if (actual > 3) paginas.push('...');

  const desde = Math.max(2, actual - 1);
  const hasta = Math.min(total - 1, actual + 1);
  for (let i = desde; i <= hasta; i++) paginas.push(i);

  if (actual < total - 2) paginas.push('...');
  paginas.push(total);

  return paginas;
}

get rangoMostrado(): string {
  if (this.planesFiltrados.length === 0) return '0 de 0';
  const inicio = (this.paginaActual - 1) * this.itemsPorPagina + 1;
  const fin = Math.min(inicio + this.itemsPorPagina - 1, this.planesFiltrados.length);
  return `${inicio}–${fin} de ${this.planesFiltrados.length}`;
}

irAPagina(pagina: number | '...'): void {
  if (pagina === '...' || pagina < 1 || pagina > this.totalPaginas) return;
  this.paginaActual = pagina;
}

paginaAnterior(): void {
  if (this.paginaActual > 1) this.paginaActual--;
}

paginaSiguiente(): void {
  if (this.paginaActual < this.totalPaginas) this.paginaActual++;
}

cambiarItemsPorPagina(): void {
  this.paginaActual = 1; // reset para no quedar en una página vacía
}
  resetearPaginacion(): void {
  this.paginaActual = 1;
}
  cargarActividadesPlanesMantenimiento(): void {
   
    //consumir el servicio para obtener las actividades de los planes de mantenimiento
    
  }
}
